/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_Common_CalculationRequestDto } from '../models/Wealthlane_AwardService_Dtos_Common_CalculationRequestDto';
import type { Wealthlane_AwardService_Dtos_Common_CalculationResultDto } from '../models/Wealthlane_AwardService_Dtos_Common_CalculationResultDto';
import type { Wealthlane_AwardService_Dtos_OptionAward_OptionAwardImportResponseDto } from '../models/Wealthlane_AwardService_Dtos_OptionAward_OptionAwardImportResponseDto';
import type { Wealthlane_AwardService_Dtos_Release_ApplyFMVReleaseResponseDto } from '../models/Wealthlane_AwardService_Dtos_Release_ApplyFMVReleaseResponseDto';
import type { Wealthlane_AwardService_Dtos_Release_CreateReleaseResponseDto } from '../models/Wealthlane_AwardService_Dtos_Release_CreateReleaseResponseDto';
import type { Wealthlane_AwardService_Dtos_Release_ReleaseDeleteResponseDto } from '../models/Wealthlane_AwardService_Dtos_Release_ReleaseDeleteResponseDto';
import type { Wealthlane_AwardService_Dtos_Release_ReleaseDto } from '../models/Wealthlane_AwardService_Dtos_Release_ReleaseDto';
import type { Wealthlane_AwardService_Dtos_Release_ReleaseItemIdsDto } from '../models/Wealthlane_AwardService_Dtos_Release_ReleaseItemIdsDto';
import type { Wealthlane_AwardService_Dtos_Release_ReleaseResponseDto } from '../models/Wealthlane_AwardService_Dtos_Release_ReleaseResponseDto';
import type { Wealthlane_AwardService_Dtos_Release_ReleaseUpdateDto } from '../models/Wealthlane_AwardService_Dtos_Release_ReleaseUpdateDto';
import type { Wealthlane_AwardService_Dtos_Release_UpdateReleaseDto } from '../models/Wealthlane_AwardService_Dtos_Release_UpdateReleaseDto';
import type { Wealthlane_AwardService_Dtos_RSUAward_RSUAwardSampleFileBlobDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_RSUAwardSampleFileBlobDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ReleaseService {

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Release_ReleaseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppReleaseRelease(
requestBody?: Wealthlane_AwardService_Dtos_Release_UpdateReleaseDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_Release_ReleaseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/release/release',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param releaseId 
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Release_ReleaseDto OK
     * @throws ApiError
     */
    public static putApiAwardApiAppReleaseRelease(
releaseId: string,
requestBody?: Wealthlane_AwardService_Dtos_Release_UpdateReleaseDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_Release_ReleaseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/release/release/{releaseId}',
            path: {
                'releaseId': releaseId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param releaseId 
     * @returns Wealthlane_AwardService_Dtos_Release_ReleaseDeleteResponseDto OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAppReleaseRelease(
releaseId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_Release_ReleaseDeleteResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/app/release/release/{releaseId}',
            path: {
                'releaseId': releaseId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param fmv 
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Release_ApplyFMVReleaseResponseDto OK
     * @throws ApiError
     */
    public static putApiAwardApiAppReleaseFMV(
fmv: number,
requestBody?: Array<Wealthlane_AwardService_Dtos_Release_ReleaseItemIdsDto>,
): CancelablePromise<Wealthlane_AwardService_Dtos_Release_ApplyFMVReleaseResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/release/f-mV',
            query: {
                'FMV': fmv,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param releaseName 
     * @returns Wealthlane_AwardService_Dtos_Release_ReleaseResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppReleaseCheckDuplicateReleaseName(
releaseName?: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_Release_ReleaseResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/release/check-duplicate-release-name',
            query: {
                'releaseName': releaseName,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param releaseId 
     * @param name 
     * @returns Wealthlane_AwardService_Dtos_Release_ReleaseDto OK
     * @throws ApiError
     */
    public static putApiAwardApiAppReleaseReleaseName(
releaseId: string,
name?: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_Release_ReleaseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/release/release-name/{releaseId}',
            path: {
                'releaseId': releaseId,
            },
            query: {
                'name': name,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Release_ApplyFMVReleaseResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppReleaseCalculateTax(
requestBody?: Array<Wealthlane_AwardService_Dtos_Release_ReleaseItemIdsDto>,
): CancelablePromise<Wealthlane_AwardService_Dtos_Release_ApplyFMVReleaseResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/release/calculate-tax',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Release_ReleaseDto OK
     * @throws ApiError
     */
    public static putApiAwardApiAppReleaseReleaseDetail(
requestBody?: Wealthlane_AwardService_Dtos_Release_ReleaseUpdateDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_Release_ReleaseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/release/release-detail',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Common_CalculationResultDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppReleaseCalculationTest(
requestBody?: Wealthlane_AwardService_Dtos_Common_CalculationRequestDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_Common_CalculationResultDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/release/calculation-test',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_RSUAwardSampleFileBlobDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppReleaseDownloadReleaseItemImportSample(): CancelablePromise<Wealthlane_AwardService_Dtos_RSUAward_RSUAwardSampleFileBlobDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/release/download-release-item-import-sample',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_AwardService_Dtos_OptionAward_OptionAwardImportResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppReleaseImportReleaseItem(
formData?: {
File?: Blob;
},
): CancelablePromise<Wealthlane_AwardService_Dtos_OptionAward_OptionAwardImportResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/release/import-release-item',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Release_CreateReleaseResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppReleaseUpsertReleaseFromBackground(
requestBody?: Wealthlane_AwardService_Dtos_Release_UpdateReleaseDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_Release_CreateReleaseResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/release/upsert-release-from-background',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
